/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import { ButtonTheme } from '../../atoms/button/button';
import './formInputTime.scss';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { unset } from 'lodash';
import InputTime from '../../atoms/inputTime/inputTime';

export const FormInputTimeType = {
  TIME: 'time',
};

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormInputTime = (props) => {
  const {
    id,
    name,
    type,
    validation,
    errorText,
    label,
    placeholder,
    helpText,
    value,
    onChange,
    configFile,
    defaultValue,
    pattern,
    multiple,
    multiline,
    disabled,
    refreshData,
    hidden,
    importButton,
    configFileImport,
    fieldToImport,
    useSeconds,
    separator,
  } = props;

  const childRef = useRef();

  const [valueState, setValueState] = useState(value !== '' ? value : defaultValue);
  const handleOnChange=(v)=>{
    onChange(v);
  }

  const handleOnCloseLoadFromCatalog = (data) => {
    if (data !== undefined && data[configFile.mainAttribute] !== undefined) {
      childRef.current.updateValue(data[configFile.mainAttribute]);
      onChange({ target: { value: data[configFile.mainAttribute] } });
    }
  };
  useEffect(() => {
    if (value !== valueState) {
      setValueState(value);
      // childRef.current.updateValue(value);
    }
  }, [value]);

  useEffect(() => {
    if(refreshData){
      unset(refreshData,"updated");
      setValueState(refreshData);
      childRef.current.updateValue(refreshData);
      onChange({ target: { value: refreshData} })
    }
    
  }, [refreshData]);
  return (
    <div className={`form-group row text-${validation} ${(hidden?"form-input-text__hidden":"")}`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        <InputTime
              id={id}
              name={name}
              type={type}
              className={(configFile) !== undefined ? 'form-input-text__input' : ''}
              validation={validation}
              placeholder={placeholder}
              value={valueState}
              useSeconds={useSeconds}
              separator={separator}
              onChange={handleOnChange}
              disabled
            />
        { (validation === FormValidation.ERROR || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
      </div>
    </div>
  );
};

FormInputTime.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input field
   */
  name: PropTypes.string.isRequired,
  /**
   * HTML input type, it is a FormInputTypes.TEXT_INPUT enum
   */
  type: PropTypes.oneOf(Object.values(FormInputTimeType)),
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}),
  /**
   * Default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * the input regular expression to control
   */
  pattern: PropTypes.instanceOf(RegExp),

  multiline:PropTypes.bool,
};

FormInputTime.defaultProps = {
  id: '',
  type: FormInputTimeType.TIME,
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  placeholder: '',
  helpText: '',
  value: '',
  onChange: () => {},
  configFile: undefined,
  defaultValue: '',
  pattern: undefined,
  multiline:false,
};

export default FormInputTime;
